// MA-238 ma241-redemption-route slice — a parent lands on /join/:code from
// the send-home card's QR/typed code BEFORE they've signed in (the entry
// point is public, see App.jsx's /join/ gate-ladder bypass). This module
// only carries the code across that sign-in/sign-up round-trip; it performs
// NO linking, NO consent write, and NO class/child lookup — that is
// deliberately deferred to a future slice (see JoinRedemption.tsx's header
// comment for why: no anon-reachable class lookup exists in this schema
// today, and building one is a real precedent shift the design+red-team
// pass explicitly declined to make in this slice).
//
// `sessionStorage` (not localStorage): the code is only relevant to THIS
// browser tab's current sign-in attempt, and should not silently resurface
// in a later, unrelated session on the same device.
//
// Storage is injectable (mirrors classRoster.ts's `randomFn` convention) so
// this is unit-testable with a fake in-memory Storage — no DOM needed.
export const PENDING_CLASS_JOIN_CODE_KEY = "pw_pending_class_join_code";

function safeStorage(storage: Storage | undefined): Storage | undefined {
  if (storage) return storage;
  return typeof sessionStorage === "undefined" ? undefined : sessionStorage;
}

export function storePendingJoinCode(code: string, storage?: Storage): void {
  const s = safeStorage(storage);
  if (!s) return;
  try {
    s.setItem(PENDING_CLASS_JOIN_CODE_KEY, code);
  } catch {
    /* private mode / quota — the code is decorative context only, never required */
  }
}

export function readPendingJoinCode(storage?: Storage): string | null {
  const s = safeStorage(storage);
  if (!s) return null;
  try {
    return s.getItem(PENDING_CLASS_JOIN_CODE_KEY);
  } catch {
    return null;
  }
}

export function clearPendingJoinCode(storage?: Storage): void {
  const s = safeStorage(storage);
  if (!s) return;
  try {
    s.removeItem(PENDING_CLASS_JOIN_CODE_KEY);
  } catch {
    /* no-op */
  }
}
